import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import '../../userListTable/Components/userListTable.css';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
const numberAndTextComparator = (valueA, valueB) => {
  return valueA?.trim()?.localeCompare(valueB?.trim());
};

const UserListHeader = [
  {
    headerName: 'User ID',
    field: 'userId',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    sortingOrder: ['asc', 'desc'],
    columnSpan: 2,
    cellEditor: MaxLengthNumericEditor,
    minWidth: Styles.Width_200,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Name',
    field: 'name',
    cellRenderer: 'nameRenderName',
    cellClass: 'frr-ellipsis-text-overlap',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    comparator: numberAndTextComparator,
    minWidth: Styles.Width_220,
    maxWidth: Styles.Width_300,
    sort: 'asc',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    columnSpan: 2,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: 'nameRenderStatus',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellClass: 'frr-ellipsis-text-overlap',
    maxWidth: Styles.Width_120,
    sort: 'asc',
    sortingOrder: ['asc', 'desc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Email Address',
    field: 'emailId',
    cellRenderer: 'nameRenderEmail',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    minWidth: Styles.Width_300,
    maxWidth: Styles.Width_350,
    cellClass: 'frr-ellipsis-text-overlap',
    columnSpan: 2,
    sort: 'asc',
    sortingOrder: ['asc', 'desc'],
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Role Description',
    field: 'roleDescription',
    cellRenderer: 'nameRenderRole',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    minWidth: Styles.Width_180,
    cellClass: 'frr-ellipsis-text-overlap',
    columnSpan: 5,
    sort: 'asc',
    sortingOrder: ['asc', 'desc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];

export default UserListHeader;
